var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7501 6.00008C13.9001 6.00008 14.8251 5.06675 14.8251 3.91675C14.8251 2.76675 13.9001 1.83342 12.7501 1.83342C11.6001 1.83342 10.6667 2.76675 10.6667 3.91675C10.6667 5.06675 11.6001 6.00008 12.7501 6.00008ZM6.50008 5.16675C7.88342 5.16675 8.99175 4.05008 8.99175 2.66675C8.99175 1.28341 7.88342 0.166748 6.50008 0.166748C5.11675 0.166748 4.00008 1.28341 4.00008 2.66675C4.00008 4.05008 5.11675 5.16675 6.50008 5.16675ZM12.7501 7.66675C11.2251 7.66675 8.16675 8.43342 8.16675 9.95841V11.8334H17.3334V9.95841C17.3334 8.43342 14.2751 7.66675 12.7501 7.66675ZM6.50008 6.83341C4.55841 6.83341 0.666748 7.80841 0.666748 9.75008V11.8334H6.50008V9.95841C6.50008 9.25008 6.77508 8.00841 8.47508 7.06675C7.75008 6.91675 7.05008 6.83341 6.50008 6.83341Z",
    fill: "#0085E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.eb0734b98244cd56298f0eafc8715460.svg";
export { ForwardRef as ReactComponent };